import {
  InfiniteData,
  useInfiniteQuery,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { notificationService } from "../services/notiService";
import { warehouseQueryKey } from "./QueryKey";
import { INotification } from "../models/Notification";

export function useNotificationInfinite(pageSize = 5) {
  return useInfiniteQuery({
    queryKey: [warehouseQueryKey.NOTIFICATIONS],
    queryFn: async ({ pageParam = 1 }) => {
      const data = await notificationService.getNotifications({
        page: pageParam as number,
        limit: pageSize,
      });
      return {
        items: data,
        nextPage:
          data.length === pageSize ? (pageParam as number) + 1 : undefined,
      };
    },
    getNextPageParam: (lastPage) => lastPage.nextPage,
    initialPageParam: 1,
  });
}
export function useReadNotification() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => notificationService.readNotification(id),
    onSuccess: () => {
      queryClient.setQueryData(
        [warehouseQueryKey.NOTIFICATIONS],
        (
          oldData: InfiniteData<{ items: INotification[]; nextPage?: number }>
        ) => {
          if (!oldData) return oldData;
          const newPages = oldData.pages.map((page) => {
            const newItems = page.items.map((item) => ({
              ...item,
              isRead: true,
            }));
            return { ...page, items: newItems };
          });
          return {
            ...oldData,
            pages: newPages,
          };
        }
      );
    },
  });
}
